import React from "react"
import { graphql } from "gatsby"
import {Helmet} from "react-helmet";
import Header from "../components/header";
import Footer from "../components/footer";
import LocalTimestamp from "../components/LocalTimestamp";
const News = ({ data: { prismicNews } }) => {
    const { data } = prismicNews;
    let summary = data.summary.text;
    if(summary){
        summary = summary.substring(0, Math.min(500,summary.length));
    }
    return (
        <div className="landingView articleView">
            <Helmet>
                <html lang="en" />
                <title>{data.title.text}</title>
                <description>{summary}</description>
            </Helmet>

            <Header />

            <div className="articleContainer">
                <article className="articleContent">
                    <div className="articleImage">
                        <img src={data.main_image.url}/>
                    </div>
                    <h1 className="articleTitle"><a target={"_blank"} href={data.link.url}>{data.title.text}</a></h1>
                    <p className="articleTimestamp"><LocalTimestamp utcTimestamp={prismicNews.first_publication_date} format={"MMMM D, YYYY"}/></p>
                    <div className="articleText" dangerouslySetInnerHTML={{ __html: data.summary.html }} >
                    </div>
                </article>
            </div>

            <Footer
                footerTitle="Request a Demo"
            />
        </div>
    )
}
export default News
export const pageQuery = graphql`
  query NewsBySlug($uid: String!) {
    prismicNews(uid: {eq: $uid}) {
        id
        uid
        last_publication_date
        first_publication_date
        data {
          link {
            url
          }
          summary {
            html
            text
          }
          main_image {
            alt
            copyright
            dimensions {
              height
              width
            }
            thumbnails
            url
          }
          title {
            html
            text
          }
        }
        type
 
      }
    }`